<template>
  <router-view />
  <div class="search-overlay" v-if="$store.state.searchMode"></div>
  <div v-if="isCookieModalVisible" class="cookie-consent-overlay"></div>
  <CookieConsentModal />
</template>

<script>

import axios from 'axios';
import store from "@/store"
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex';
import CookieConsentModal from '@/components/CookieConsent/CookieConsentModal.vue';

const localeLangMap = {
    'EN_US': 'en',
    'ZH_TW': 'zh-TW',
    'ZH_CN': 'zh-CN'
};

export default {
  name: 'App',
  components: {
    CookieConsentModal
  },
  setup() {
    const { t, locale } = useI18n()
    const vuexStore = useStore();
    const isCookieModalVisible = computed(() => vuexStore.state.cookieConsent?.isModalVisible ?? false);

    watch(locale, (newLocale) => {
        document.documentElement.lang = localeLangMap[newLocale] || 'en';
    }, { immediate: true });

    return {
      t,
      locale,
      isCookieModalVisible,
    }
  },
  data() {
    return {
      menu: null,
      status: null
    }
  },
  async mounted() {
    await this.getMenu();
    this.$router.afterEach((to, from) => {
      if (to.fullPath !== from.fullPath) {
        this.$store.commit('setSearchMode', false);
      }
    });
  },
  methods: {
    async getMenu() {
      this.menu = (await axios.post("/api/PegaPortal/GetSystemMenuList", { Type: "Header", SystemType: this.$store.state.systemType })).data;
      store.commit('setMenu', this.menu);
      this.status = (await axios.post("/api/PegaPortal/GetSystemMenuStatus", { Type: "Header", SystemType: this.$store.state.systemType })).data;
      store.commit('setStatus', this.status);
    }
  }
};
</script>